import ImpactDirectionByTexture from './ImpactDirectionByTexture';
export default ImpactDirectionByTexture;
